import PageComponent from '@gameday/common/components/form/Pages/Participants'
import { useMemo, useRef } from 'react'
import { convertFormType, generateRandomString } from '../../../../utils/common'

const ParticipantsComponent = ({
  members,
  registrations,
  selectParticipant,
  isGuestSignup,
  isTeamEvent,
  teamFormType,
  formSettings,
  formInfo,
  accountDetails,
  ...rest
}) => {
  const sfidRef = useRef(generateRandomString(18))
  const selfMember = useMemo(() => {
    if (!accountDetails?.email || !accountDetails?.firstName || !accountDetails?.lastName) {
      return null
    }
    return {
      sfid: sfidRef.current,
      firstname: accountDetails.firstName,
      lastname: accountDetails.lastName,
      email: accountDetails.email,
      birthdate: accountDetails.birthDate || '',
      genderIdentity: accountDetails.genderIdentity || '',
      mobile: accountDetails.phone || '',
      isNewMember: true,
    }
  }, [accountDetails])

  return (
    <PageComponent
      onSelected={value => {
        selectParticipant(value)
      }}
      members={members}
      registrations={registrations}
      isTeamEvent={isTeamEvent}
      teamFormType={teamFormType}
      formSettings={formSettings}
      formType={convertFormType(formSettings.formType) || convertFormType(formInfo?.form?.type)}
      selfMember={selfMember}
      {...rest}
    />
  )
}

ParticipantsComponent.defaultProps = {
  members: null,
  registrations: null,
}

export default ParticipantsComponent
